export const DEFAULT_PAGE_LIMIT = 50;
export const MAX_PAGE_LIMIT = 50_000;
export const DEFAULT_BUCKET_OBJECTS_LIMIT = 50;
export const MAX_BUCKET_OBJECTS_LIMIT = 1000;
